'use strict';

exports.__esModule = true;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _layouts = require('../utils/layouts');

var _widgetsUtils = require('widgets-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DoctifyWfMicroStar = function (_WfAbstractComponent) {
    (0, _inherits3.default)(DoctifyWfMicroStar, _WfAbstractComponent);

    function DoctifyWfMicroStar() {
        (0, _classCallCheck3.default)(this, DoctifyWfMicroStar);
        return (0, _possibleConstructorReturn3.default)(this, _WfAbstractComponent.apply(this, arguments));
    }

    DoctifyWfMicroStar.prototype.render = function render() {
        var props = this.props;
        switch (props.layoutType) {
            case _layouts.WF_MICRO_STAR_A:
                return (0, _layouts.MicroStar_A)(props);
            case _layouts.WF_MICRO_STAR_B:
                return (0, _layouts.MicroStar_B)(props);
            case _layouts.WF_MICRO_STAR_C:
                return (0, _layouts.MicroStar_C)(props);
            case _layouts.WF_MICRO_STAR_D:
                return (0, _layouts.MicroStar_D)(props);
            case _layouts.WF_MICRO_STAR_E:
                return (0, _layouts.MicroStar_E)(props);
            case _layouts.WF_MICRO_STAR_F:
                return (0, _layouts.MicroStar_F)(props);
            case _layouts.WF_MICRO_STAR_G:
                return (0, _layouts.MicroStar_G)(props);
            case _layouts.WF_MICRO_STAR_H:
                return (0, _layouts.MicroStar_H)(props);
            case _layouts.WF_MICRO_STAR_I:
                return (0, _layouts.MicroStar_I)(props);
            default:
                return (0, _layouts.MicroStar_A)(props);
        }
    };

    return DoctifyWfMicroStar;
}(_widgetsUtils.WfAbstractComponent);

DoctifyWfMicroStar.displayName = 'DoctifyWfMicroStar';

DoctifyWfMicroStar.propTypes = {
    averageRating: _propTypes2.default.number,
    profileUri: _propTypes2.default.string,
    layoutType: _propTypes2.default.oneOf([_layouts.WF_MICRO_STAR_A, _layouts.WF_MICRO_STAR_B, _layouts.WF_MICRO_STAR_C, _layouts.WF_MICRO_STAR_D, _layouts.WF_MICRO_STAR_E, _layouts.WF_MICRO_STAR_F, _layouts.WF_MICRO_STAR_G, _layouts.WF_MICRO_STAR_H]),
    wrapperFrame: _propTypes2.default.bool
};

DoctifyWfMicroStar.defaultProps = {
    layoutType: _layouts.WF_MICRO_STAR_A,
    wrapperFrame: true
};

exports.default = DoctifyWfMicroStar;